// utils/handleInfiniteScroll.ts
import React from 'react';

type Params = {
    e: React.UIEvent<HTMLDivElement>;
    hasNextPage: boolean | undefined;
    isFetching: boolean;
    fetchNextPage: () => void;
    offset?: number;
};

export function handleInfiniteScroll({
    e,
    hasNextPage,
    isFetching,
    fetchNextPage,
    offset = 2,
}: Params) {
    const target = e.currentTarget;

    if (
        target.scrollTop + target.clientHeight >=
        target.scrollHeight - offset
    ) {
        if (hasNextPage && !isFetching) {
            fetchNextPage();
        }
    }
}

export const hasOnlyNumber = (name: string) => /^\d+$/.test(name);
